'use strict';

var parseServerTimingHeader = function parseServerTimingHeader(response) {
  if (!response || !response.headers) {
    return [];
  }
  var serverTiming = response.headers.get('server-timing');
  if (!serverTiming) {
    return [];
  }
  return serverTiming.split(',').reduce(function (acc, x) {
    var match = x.match(/([^;]+);dur=([\d.]+)/);
    if (match) {
      acc.push({ key: match[1], value: Number(match[2]) });
    }
    return acc;
  }, []);
};

module.exports = parseServerTimingHeader;